export const validation = {
  maxTitleChar: 2000
}